/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebErrorItemModel
 */
export interface FrontWebErrorItemModel {
    /**
     * Path
     * @type {string}
     * @memberof FrontWebErrorItemModel
     */
    path: string;
    /**
     * Popis
     * @type {string}
     * @memberof FrontWebErrorItemModel
     */
    error: string;
}

/**
 * Check if a given object implements the FrontWebErrorItemModel interface.
 */
export function instanceOfFrontWebErrorItemModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "path" in value;
    isInstance = isInstance && "error" in value;

    return isInstance;
}

export function FrontWebErrorItemModelFromJSON(json: any): FrontWebErrorItemModel {
    return FrontWebErrorItemModelFromJSONTyped(json, false);
}

export function FrontWebErrorItemModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebErrorItemModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
        'error': json['error'],
    };
}

export function FrontWebErrorItemModelToJSON(value?: FrontWebErrorItemModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'error': value.error,
    };
}

